<template>
    <el-dialog 
        title="添加任务" 
        :visible.sync="dialogVisible" 
        width="700px"
        :before-close="handleClose"
        @open="onDialogOpen"
    >
        <div class="xm-alert">
            <div class="xm-alert-icon">
                <i class="el-icon-warning-outline"></i>
            </div>
            <div class="xm-alert-content">
                <div class="xm-alert-title">任务时间注意： 每周日晚上设置修改现货时间最晚19：00；每周一凌晨设置修改预售时间最早06：00； 同店铺任务相隔最少15分钟；</div>
            </div>
        </div>
        <div class="sync-product-dialog">
            <!-- 是否预售 -->
            <div class="query-row">
                <div class="query-item">
                    <div class="query-item-title">是否预售：</div>
                    <div class="query-item-content">
                        <el-radio size="small" v-model="filter.isPreOrder" label="1" @input="handleChangePreOrder">现货，需1天内发货</el-radio>
                        <el-radio size="small" v-model="filter.isPreOrder" label="2" @input="handleChangePreOrder">预售</el-radio>
                    </div>
                </div>
            </div>
            <!-- 发货天数 -->
            <div class="query-row" v-if="filter.isPreOrder === '2'">
                <div class="query-item">
                    <div class="query-item-title">发货天数：</div>
                    <div class="query-item-content">
                        <el-input-number size="small" v-model="filter.shipDays" :min="3" :max="30" label="发货天数"></el-input-number>
                    </div>
                </div>
            </div>
            <!-- 执行方式 -->
            <div class="query-row">
                <div class="query-item">
                    <div class="query-item-title">执行方式：</div>
                    <div class="query-item-content">
                        <el-radio size="small" v-model="filter.taskType" label="1" @input="handleChangeTaskType">立即执行</el-radio>
                        <el-radio size="small" v-model="filter.taskType" label="2" @input="handleChangeTaskType">定时执行</el-radio>
                    </div>
                </div>
            </div>
            <!-- 执行时间 -->
            <div class="query-row" v-if="filter.taskType === '2'">
                <div class="query-item">
                    <div class="query-item-title">执行时间：</div>
                    <div class="query-item-content">
                        <el-date-picker
                            size="small"
                            v-model="filter.taskTime"
                            format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'SyncProductDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            filter: {
                isPreOrder: '2',
                shipDays: null,
                taskType: '1',
                taskTime: null,
            },
            shops: [],
            selectedShops: [],
            selectAllShops: false,
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        handleChangePreOrder(value) {
            if (this.filter.isPreOrder === '1') {
                this.filter.shipDays = 0;
            }
        },
        handleChangeTaskType(value) {
            if (this.filter.taskType === '1') {
                this.filter.taskTime = null;
            }
        },
        onDialogOpen() {
            this.filter = {
                isPreOrder: '2',
                shipDays: null,
                taskType: '1',
                taskTime: null,
            }
        },
        handleClose() {
            this.dialogVisible = false;
            this.resetForm();
        },
        handleConfirm() {
            const params = {
                ...this.filter,
            };
            this.$emit('confirm', params);
            this.handleClose();
        },
        resetForm() {
            this.filter = {
                platform: 'all',
                region: 'all',
                status: 'onsale',
                updateTime: []
            };
        },
    }
}
</script>

<style scoped>
.sync-product-dialog {
    margin-top: 20px;
    margin-bottom: -20px;
}

.query-row {
    margin-top: 30px;
    margin-bottom: 15px;
}

.query-item {
    display: flex;
    align-items: top;
}

.query-item-title {
    width: 100px;
    min-width: 100px;
    text-align: right;
    margin-top: 4px;
    font-size: 14px;
    color:#000000;
}
.el-radio{
    color:#000000;
}
.query-item-content {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    margin-left: 20px;
}

.custom-radio {
    display: inline-block;
    cursor: pointer;
    user-select: none;
}

.custom-radio input[type="radio"] {
    display: none;
}

.custom-radio-btn {
    display: inline-block;
    padding: 1px 12px;
    height: 28px;
    line-height: 29px;
    background: rgba(0,0,0,0.09);
    border-radius: 2px;
    color: #333;
    border: 1px solid transparent;
    transition: all 0.2s;
    font-size: 14px;
}

.custom-radio:hover .custom-radio-btn {
    background: #f2f3ff;
    color: #0052d9;
}

.custom-radio input[type="radio"]:checked + .custom-radio-btn {
    background: #f2f3ff;
    color: #0052d9;
    border: 1px solid #0052d9;
    white-space: nowrap;
}

.shop-list-container {
    width: 100%;
    margin-top: 10px;
}

.shop-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px;
}

.shop-item {
    display: flex;
    align-items: center;
    padding: 4px 0;
    flex: 0 0 auto;
}

.shop-item .el-checkbox {
    width: 100%;
}

.shop-item .el-checkbox__label {
    font-size: 13px;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dialog-footer {
    text-align: right;
    padding-top: 20px;
    border-top: 1px solid #e8e8e8;
}

.dialog-footer .el-button {
    margin-left: 10px;
}

/* Alert样式 */
.xm-alert {
    width: 650px;
    padding: 16px 20px;
    border-radius: 6px;
    background: rgb(255, 217, 194);
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    box-sizing: border-box;
}

.xm-alert-icon {
    margin-right: 10px;
    margin-top: 2px;
    flex-shrink: 0;
}

.xm-alert-icon i {
    color: rgb(227, 115, 24);
    font-size: 16px;
}

.xm-alert-content {
    flex: 1;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.xm-alert-title {
    font-weight: 500;
    white-space: normal;
}

.xm-alert-desc {
    flex-shrink: 0;
}

.xm-alert-close {
    margin-left: 12px;
    margin-top: 2px;
    flex-shrink: 0;
    cursor: pointer;
}

.xm-alert-close i {
    color: rgba(0, 0, 0, 0.6);
    font-size: 16px;
}

.xm-alert-close:hover i {
    color: rgba(0, 0, 0, 0.8);
}
</style>
